module.exports = __webpack_public_path__ + "img/szls-bg.a91bf47b.png";